<template>
	<div class="goods-form-wrapper" @keypress.esc="cancel">
		<div class="header-sidebar mb-4" slot="header">
			<h4 class="pull-left">
				{{ formItem.title }}
			</h4>
			<b-button class="pull-right close-btn" @click="cancelAndClearInventory" type="button" variant="link" :disabled="loading"><i
				class="fa fa-close"></i></b-button>
			<div class="clearfix"></div>
			<hr>
		</div>
		<b-form>
			<b-row>
				<b-col  cols="6">
					<b-form-group
						breakpoint="lg"
						label-size="sm"
						label-cols="4"
						label-for="refName"
						class="required ml-1"
						size="sm"
					>
						<template slot="label">
							{{ $t('incomes.create.from-warehouse')}} <span class="text-danger">*</span>
						</template>
						<b-form-select
							size="sm"
							:options="departments"
							v-model="formItem.toDepartmentId"
							disabled
						>
							<template slot="first">
								<option :value="null" disabled>-- {{ $t('incomes.create.warehouse') }} --</option>
							</template>
						</b-form-select>

					</b-form-group>
				</b-col>

				<b-col  cols="6" v-if="formItem.fromDepartmentId !== false">
					<b-form-group
						breakpoint="lg"
						label-size="sm"
						label-cols="4"
						label-for="refName"
						class="required ml-1"
						size="sm"
					>
						<template slot="label">
							{{ $t('incomes.create.from-warehouse')}} <span class="text-danger">*</span>
						</template>
						<b-form-select
							size="sm"
							v-model="formItem.fromDepartmentId"
						>
							<option v-for="(selectOption, indexOpt) in departments"
									:key="indexOpt"
									:value="selectOption.id"
									:disabled="selectOption.value === formItem.fromDepartmentId || !selectOption.saleType"
									:style="!selectOption.saleType ? 'color:red' : ''"
							>
								{{selectOption.text}}
							</option>
							<template slot="first">
								<option :value="null" disabled>-- {{ $t('incomes.create.warehouse') }} --</option>
							</template>
						</b-form-select>

					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col  cols="12">
					<b-form-group
						breakpoint="lg"
						label-size="sm"
						label-cols="2"
						:label="$t('incomes.create.reason')"
						label-for="refName"
						label-class="ml-1"
						class="required"
						size="sm"
					>
						<b-form-input :required="true"
									  size="sm"
									  id="reason"
									  v-model="formItem.reason"
									  :placeholder="$t('incomes.create.reason')"></b-form-input>
					</b-form-group>
				</b-col>
			</b-row>

			<b-row>
				<b-col cols="6" v-if="formItem.responsible1 !== false">
					<b-form-group
						breakpoint="lg"
						label-size="sm"
						label-cols="4"
						label-for="refName"
						class="required ml-1"
						size="sm"
					>
						<template slot="label">
							{{ $t('inventory.responsible') }}
						</template>
						<b-form-select v-model="formItem.responsible1"
									   :plain="false"
									   size="sm"
									   id="responsible1"
									   :text-field="'name'"
									   :value-field="'id'"
						>
							<option v-for="(selectOption, indexOpt) in respPersonList"
									:key="indexOpt"
									:value="selectOption.id"
							>
								{{selectOption.firstName}} {{selectOption.lastName}} {{selectOption.middleName}}
							</option>
							<template slot="first">
								<option :value="null" disabled> -- {{ $t('inventory.responsible') }} --
								</option>
							</template>
						</b-form-select>
					</b-form-group>
				</b-col>
			</b-row>

			<div class="mt-1" v-if="1===2">
				<b-button class="pull-right" size="sm" v-b-toggle.collapse1 variant="light">
					<i class="fa fa-plus-circle"></i> {{ $t('incomes.create.additional') }}
				</b-button>
				<div class="clearfix"></div>
				<b-collapse id="collapse1" class="mt-2">
					<div class="mt-1">
						<b-row>
							<b-col cols="6">
								<b-form-group
									breakpoint="lg"
									label-size="sm"
									label-cols="4"
									:label="$t('incomes.create.from')"
									label-for="refName"
									class="required mb-1"
								>
									<multiselect class="pull-left with-clear" v-model="dropDowns.employees.from"
												 :options="employees"
												 :searchable="true"
												 :loading="dropDowns.product.loading"
												 :close-on-select="true"
												 label="name"
												 :selectLabel="''"
												 :deselectLabel="''"
												 track-by="id"
												 :custom-label="fullName"
												 @search-change="fetchEmployees($event)"
												 :placeholder="$t('incomes.create.select-employee')">

										<template slot="singleLabel" slot-scope="props">
											{{ props.option.firstName }}
										</template>
									</multiselect>
									<b-button class="pull-right" @click="dropDowns.employees.from = null"
											  style="position: absolute; right:6px" size="sm" variant="light">x
									</b-button>
									<div class="clearfix"></div>
								</b-form-group>
							</b-col>
							<b-col cols="6">
								<b-form-group
									breakpoint="lg"
									label-size="sm"
									label-cols="4"
									:label="$t('incomes.create.to')"
									label-for="refName"
									class="required mb-1"
								>
									<multiselect class="pull-left with-clear" v-model="dropDowns.employees.to"
												 :options="employees"
												 :searchable="true"
												 :selectLabel="''"
												 deselectLabel="''"
												 :loading="dropDowns.product.loading"
												 :close-on-select="true"
												 label="name"
												 track-by="id"
												 :custom-label="fullName"
												 @search-change="fetchList($event)"
												 :placeholder="$t('incomes.create.select-employee')">

										<template slot="singleLabel" slot-scope="props">
											{{ props.option.firstName }}
										</template>
									</multiselect>
									<b-button class="pull-right" @click="dropDowns.employees.to = null"
											  style="position: absolute; right:6px" size="sm" variant="light">x
									</b-button>
									<div class="clearfix"></div>
								</b-form-group>
							</b-col>
						</b-row>
						<b-row>
							<b-col cols="6">
								<b-form-group
									breakpoint="lg"
									label-size="sm"
									label-cols="4"
									:label="$t('incomes.create.responsible')"
									label-for="refName"
									class="required mb-1"
								>
									<multiselect class="pull-left with-clear" v-model="dropDowns.employees.responsible"
												 :options="employees"
												 :searchable="true"
												 :selectLabel="''"
												 deselectLabel="''"
												 :loading="dropDowns.product.loading"
												 :close-on-select="true"
												 label="name"
												 track-by="id"
												 :custom-label="fullName"
												 @search-change="fetchEmployees($event)"
												 :placeholder="$t('incomes.create.select-employee')">

										<template slot="singleLabel" slot-scope="props">
											{{ fullName(props.option) }}
										</template>
									</multiselect>
									<b-button class="pull-right" @click="dropDowns.employees.responsible = null"
											  style="position: absolute; right:6px" size="sm" variant="light">x
									</b-button>
									<div class="clearfix"></div>
								</b-form-group>
							</b-col>
							<b-col cols="6">
								<b-form-group
									breakpoint="lg"
									label-size="sm"
									label-cols="4"
									:label="$t('incomes.create.responsible')"
									label-for="refName"
									class="required mb-1"
								>
									<multiselect class="pull-left with-clear" v-model="dropDowns.employees.responsible2"
												 :options="employees"
												 :searchable="true"
												 :selectLabel="''"
												 deselectLabel="''"
												 :loading="dropDowns.product.loading"
												 :close-on-select="true"
												 label="name"
												 track-by="id"
												 :custom-label="fullName"
												 @search-change="fetchEmployees($event)"
												 :placeholder="$t('incomes.create.select-employee')">

										<template slot="singleLabel" slot-scope="props">
											{{ props.option.firstName }}
										</template>
									</multiselect>
									<b-button class="pull-right" @click="dropDowns.employees.responsible2 = null"
											  style="position: absolute; right:6px" size="sm" variant="light">x
									</b-button>
									<div class="clearfix"></div>

								</b-form-group>
							</b-col>
							<b-col cols="6">
								<b-form-group
									breakpoint="lg"
									label-size="sm"
									label-cols="4"
									:label="$t('incomes.create.initiator')"
									label-for="refName"
									class="required mb-1"
								>
									<multiselect class="pull-left with-clear" v-model="dropDowns.employees.initiator"
												 :options="employees"
												 :searchable="true"
												 :selectLabel="''"
												 deselectLabel="''"
												 :loading="dropDowns.product.loading"
												 :close-on-select="true"
												 label="name"
												 track-by="id"
												 :custom-label="fullName"
												 @search-change="fetchEmployees($event)"
												 :placeholder="$t('incomes.create.initiator')">

										<template slot="singleLabel" slot-scope="props">
											{{ props.option.firstName }}
										</template>
									</multiselect>
									<b-button class="pull-right" @click="dropDowns.employees.initiator = null"
											  style="position: absolute; right:6px" size="sm" variant="light">x
									</b-button>
									<div class="clearfix"></div>
								</b-form-group>
							</b-col>

						</b-row>
					</div>
				</b-collapse>
			</div>
			<br>
			<hr>

				<div class="generalTableClass table-responsive-true">
					<b-table
						:items="formItem.whItems"
						:fields="fields"
						hover="hover"
						striped="striped"
						bordered="bordered"
					>
						<!-- EMPTY SLOT FOR TABLE -->
						<template slot="empty" slot-scope="scope">
							<h4>{{ $t('empty') }}</h4>
						</template>
						<template slot="id" slot-scope="data">
							{{ data.index + 1 }}
						</template>

						<!-- EMPTY SLOT FOR TABLE -->
						<template slot="artikul" slot-scope="data">
							{{ data.item.artikul }}
						</template>
						<template slot="color" slot-scope="data">
							{{ data.item.color }}
						</template>
						<template slot="size" slot-scope="data">
							{{ data.item.size }}
						</template>
						<template slot="realBalance" slot-scope="data">
							{{ data.item.realBalance>0?data.item.realBalance:0 }}
						</template>
						<template slot="itemName" slot-scope="data">
							<span v-if="data.item.wrapped"><strong>Упаковка - </strong>{{ data.value ? data.value.substring(0, 30) : '-' }}</span>
							<span v-else>{{ data.value ? data.value.substring(0, 30) : '-' }}</span>
						</template>
						<template slot="difference" slot-scope="data">
							<div>
								{{Math.abs(data.item.difference) ? Math.abs(data.item.difference) : Math.abs(data.item.count)}}
							</div>
						</template>
					</b-table>
				</div>

<!--			<div class="text-center mb-3" v-if="!showItems">-->
<!--				<b-spinner size="sm" variant="primary"></b-spinner>-->
<!--			</div>-->
			<b-row>
				<b-col cols="3"></b-col>
				<b-col cols="9">
					<b-form-group
						breakpoint="lg"
						label-size="sm"
						label-cols="2"
						:label="$t('comment')"
						label-for="refName"
						class="required"
					>
						<b-form-textarea
							v-model="formItem.comment"
							:placeholder="$t('comment')"
						></b-form-textarea>
					</b-form-group>

				</b-col>
			</b-row>
		</b-form>
		<div class="modal-actions">
			<b-row class="align-items-center">
				<b-col cols="6" class="mb-3 mb-xl-0">
					<b-row>
						<b-col cols="3">
							<b-button block size="sm" type="button" @click="cancelAndClearInventory" :disabled="loading"
									  variant="outline-danger">{{
								$t('cancel') }}
							</b-button>
						</b-col>

						<b-col cols="6">
							<b-button block type="button" class="btn btn-success"
									  size="sm" @click="save"
									  :disabled="!formItem.whItems.length > 0 || loading"
									  variant="primary">{{ $t('warehouse.document.saveAndFinish') }}

							</b-button>
						</b-col>
					</b-row>
				</b-col>
			</b-row>
		</div>
		<b-modal
			v-model="depWarning"
			hide-title="true"
			ref="depWarningModal"
			@ok="depWarningOk"
			@cancel="depWarningCancel"
			ok-title="Да"
			cancel-title="Отмена"
		>
			<h5>Вы изменили отдел, в этом случае удаляется все добавленные товары. Продолжать? </h5>
		</b-modal>
	</div>
</template>

<script>

	import ContrAgentSelect from "../../../references/blocks/ContrAgentSelect";
	import ContrAgentService from "../../../../services/contragent.service";
	import UsersService from "../../../../services/users.sevice";
	import WhDocument from "../../../../services/wh-document.service";
	import Multiselect from 'vue-multiselect'
	import ItemList from "../../wh-documents/blocks/ItemList";
	import Employees from "../../wh-documents/mixins/Employee";
	import MaskedInput from 'vue-masked-input';
	import {mapGetters, mapState, mapActions} from "vuex";

	import {validators} from "../mixins/validators";

	export default {
		name: 'CreateForm',

		mixins: [Employees, validators],

		components: {
			ContrAgentSelect,
			MaskedInput,
			Multiselect,
			SelectOrCreate: () => import('../../../components/SelectOrCreate'),
			ItemList
		},
		props: {
			formItem: {
				type:Object
			},
			respPersonList: {
				type: Array,
			},
		},

		data: function () {
			return {
				fromDepartmentId:null,
				reason:null,
				regNumber:null,
				regDate:null,
				comment:null,
				currencyId:null,
				depWarning: false,
				loading:false,
				dropDowns: {

					department: {
						items: [],
						value: null
					},
					counterparties: {
						items: [],
						value: null
					},
					product: {

						loading: false,

					},
					employees: {
						from: null,
						to: null,
						responsible: null,
						responsible2: null,
						initiator: null
					},


				},
				sectordId: null,
				fields: [
					{
						key: 'id',
						label: '№',
						sortable: true
					},
					{
						key: 'artikul',
						label: this.$t('goods.artikul'),
						'class': 'incomeItemArtikul',
						sortable: true,
						visible: true,
						changebale: true
					},
					{
						key: 'color',
						label: this.$t('goods.color'),
						'class': 'incomeItemArtikul',
						sortable: true,
						visible: true,
						changebale: true
					},
					{
						key: 'size',
						label: this.$t('goods.size'),
						'class': 'incomeItemSize',
						sortable: true,
						visible: true,
						changebale: true
					},
					{
						key: 'itemName',
						label: this.$t('incomes.create.product'),
						'class': 'not-first',
						sortable: true,
						visible: true,
						changebale: true
					},
					{
						key: 'difference',
						label: this.$t('incomes.create.count'),
						'class': 'td-30',
						sortable: true,
						visible: true,
						changebale: true
					},

				],
			}

		},

		methods: {
			cancelAndClearInventory(){
				this.$emit('cancel');
			},
			async cancel() {
				this.$emit('cancel');
			},
			clearFormItems(){
				this.formItem.whItems.forEach((item,index) => {
					this.formItem.whItems[index].count = Math.abs(this.formItem.whItems[index].difference);
					delete this.formItem.whItems[index].difference;
					delete this.formItem.whItems[index].incomingPrice;
					delete this.formItem.whItems[index].inventory;
					delete this.formItem.whItems[index].inventoryId;
					delete this.formItem.whItems[index].inventoryNumber;
					delete this.formItem.whItems[index].id;
					delete this.formItem.whItems[index].priceUzs;
					delete this.formItem.whItems[index].sub2CategoryName;
					delete this.formItem.whItems[index].priceWholeSale;
					delete this.formItem.whItems[index].categoryName;

				});
			},
			async save(){
				this.loading = true;
				if(this.formItem.action === 'SPISAT'){
					this.formItem.fromDepartmentId = this.formItem.toDepartmentId;
					delete this.formItem.toDepartmentId;
				}
				await this.clearFormItems();
				let inventory_id = this.formItem.inventoryId;
				delete this.formItem.title;
				delete this.formItem.inventoryId;
				Object.keys(this.formItem).forEach((key) => (this.formItem[key] === false) && delete this.formItem[key]);
				await WhDocument.saveInvenotoryDocument(this.formItem,inventory_id).then(response => {
					if(response.data){
						this.$vs.notify({
							time: 5000,
							title: this.$t('action_success'),
							color: 'success',
							icon: 'close',
							position: 'top-right'
						});
					}else{
						this.$vs.notify({
							time: 5000,
							title: this.$t('action_fail'),
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						});
					}


				});
				this.loading = false;

				await this.cancelAndClearInventory();
				this.$router.push(`/warehouse-management/inventory`);



			},
			depWarningCancel(){

			},
			depWarningOk(){

			},
			fullName({firstName, lastName, middleName}) {
				return `${firstName} ${lastName} ${middleName}`;
			},
			setSector(sectorId) {
				if (sectorId) {
					let temp = [];
					for (let i = 0; i < this.formItem.sectors.length; i++) {
						if (sectorId === this.formItem.sectors[i].id) {
							temp = this.formItem.sectors[i].name;
						}

					}
					return temp
				} else {
					return 0
				}
			},
			async loadSector(id) {
				await WhDocument.getSectorByDepartmentId(id).then(response => {
					this.dropdowns.sector= response;
					this.$store.commit('warehouse/setSector', this.dropdowns.sector);


				})
			},
			fetchList() {
				ContrAgentService.search({
					page: 1, limit: 700
				}).then(response => {
					this.dropDowns.counterparties.items = response.data.items;
				})
			},

			/**
			 *
			 */
			fetchPermissions() {
					UsersService.getPermittedDepartments().then(response => {
						this.dropDowns.department.items = response.data.permittedDepartments;
						this.dropDowns.transferPermittedDepartments = response.data.transferPermittedDepartments
					})

			},

			/**
			 * Store Warehouse document
			 */



			setDocType() {
				// if (this.isChiqim || this.isTransfer) {
				// 	this.formtItem.documentType = 'AKT';
				// }
				// if (this.isOff) {
				// 	this.formtItem.documentType = 'PROTOKOL';
				// }
			},


		},

		created() {

		},
		async mounted() {
			this.fetchList();
			this.fetchPermissions();

		},

		watch: {
			'sectordId': {
				handler(newValue){
					this.formItem.whItems.forEach( (item,index) => {
						this.formItem.whItems[index].sectorId = newValue;
					})
				}
			}

		},

		computed: {
			...mapState('references', [
				'refCurrencies'
			]),

			computedDepCurrencyName() {
				return this.depCurrencyName || this.userDepCurrencyName;
			},
			departments() {
				const departments = [];
				this.dropDowns.department.items.map(item => {
						departments.push({
							value: item.id,
							text: `${item.name} ${(item.parentName) ? '-' + item.parentName : ''}`,
							saleType: item.saleType
						});
				});
				return departments;
			},


		}
	}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
	.fromCurrencyRateId + div {
		padding: 0 !important;
	}
</style>
